// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".envTxt {\n  z-index: 999;\n  padding: 0 10px;\n  position: fixed;\n  bottom: 10px;\n  right: 0px;\n  font-weight: 700;\n  font-size: 1.1em;\n  color: #fff !important;\n  background: red;\n  border-radius: 10px 0px 0px 10px;\n}", ""]);
// Exports
module.exports = exports;
